/** Non-default locale URL prefixes (`/zh`, `/cn`, …). Keep in sync with `nuxt.config.ts`. */
const BLOG_LOCALE_PREFIXES = [
  'ru',
  'ja',
  'id',
  'ar',
  'cn',
  'de',
  'es',
  'fr',
  'it',
  'kr',
  'nl',
  'pt',
  'tr',
  'zh',
] as const

/**
 * Blog is English-only. Any `/{locale}/blog…` navigation → `/blog…`.
 * Complements nitro `routeRules` redirects for client-side locale switches.
 */
export default defineNuxtRouteMiddleware((to) => {
  const segments = to.path.split('/').filter(Boolean)
  if (segments.length < 2) return
  const [maybeLocale, maybeBlog, ...rest] = segments
  if (
    !BLOG_LOCALE_PREFIXES.includes(
      maybeLocale as (typeof BLOG_LOCALE_PREFIXES)[number],
    ) ||
    maybeBlog !== 'blog'
  ) {
    return
  }
  const target = rest.length ? `/blog/${rest.join('/')}` : '/blog'
  if (to.path === target) return
  return navigateTo(
    { path: target, query: to.query, hash: to.hash },
    { redirectCode: 301 },
  )
})
